module.exports = __webpack_public_path__ + "img/SKLB-Incidencias 1.1f2645de.png";